import React from 'react';
// import Modal from '@material-ui/core/Modal';

const EmptyCountryDialog = (props) => {
	return (
		<div>
              This country does not have songs. Be the first to add one!  
		</div>
	);

};

export default EmptyCountryDialog;